<div class="container mt-lg-4 mt-0">
  <div class="card game-card bg-primary d-flex align-items-center justify-content-center">
    <h4 class="text-white">{{ 'player.reveal.heading' | translate }}</h4>
    <button
      class="card card-sm bg-white text-primary fw-bold flex justify-content-center align-items-center cursor-pointer"
      (click)="launchGame(playerRevealURL)"
    >
      {{ 'player.reveal.play' | translate }}
    </button>
  </div>
</div>

<!--Modal to welcome back user after game-->
<ng-template #gameCallback let-modal>
  <div ngbAutofocus>
    <div class="d-flex align-items-center flex-column modal-height bg-white">
      <div class="text-white mb-3 w-100">
        <h4 class="card-header text-center bg-primary py-3">{{ 'bingo.title' | translate }}</h4>
        <div class="card-body font-size-14 text-center mt-3">
          <p class="card-text text-black" [innerHTML]="'bingo.info' | translate | markdownTranslate"></p>
        </div>
        <div class="text-center">
          <button (click)="modal.dismiss()" class="btn btn-primary close-button bg-primary text-white border-0 fw-bold mt-2">
            {{ 'button.close' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
